import listComponent from '@/util/proto/listComponent'

export default {
  extends: listComponent,
  props:['id'],
  data() {
    return {
      columns: [
        {
          title: '处罚时间',
          key: 'punishDatetimeText',
        },
        {
          title: '违规行为',
          key: 'reason',
        },
        {
          title: '扣分',
          key: 'score',
          width:80
        },
        {
          title: '处罚金额',
          key: 'amount',
        },
        {
          title: '备注',
          key: 'remark',
        },
      ],
      data: [],
    }
  },

  created(){
    this.$watch('id' , function(nv){
      if(nv){
        this.search()
      }else{
        this.data = []
      }
    },{immediate:true})
    
  },
  methods: {
    search(){
      let params = { search:this.id, pageSize: this.page.pageSize, pageNum: this.page.pageNum , orders:this.page.orders }
      this.loading = true
      this.$request.licenseExamRecords(params).then(resp => {
        this.loading = false
        this.data = this.$utils.conv(resp.data.list || [] , { 'punishDatetime':'datetime'})
        this.page.total = resp.data.total
      })
    },
    view(){

    }
  },

  render(){
    const data = this.data || {}

    return <sl-table showHeader={true} loading={this.loading} page={this.page} columns={this.columns} data={this.data} on-change={this.$tableChange} />
  }
}
